<template>
  <div class="container">
    <div class="swipper">
      <el-carousel
        height="370px"
        :interval="3000"
        arrow="always"
        trigger="click"
      >
        <el-carousel-item
          v-for="(item,index) in tuList"
          :key="index"
        >
          <img class="swipper-img" :src="item.img" alt="banner" />
          <div class="desc">
            <p>{{item.title}}</p>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="nes-wrapper">
      <div class="nes-header">
        <div
          v-for="(item,index) in newsList"
          :key="index"
          @mouseover="setIndex(index)"
          :class="showIndex===index?'header-item-active':''"
          class="header-item"  >
          <span  @click="toList(item.id)"> {{item.name}}</span>
          <!--          <div id="san"></div>-->
        </div>
        <div class="nes-add"
             @click="toList(newsList[0].id)"
        >更多></div>
      </div>
      <div
        v-for="(i,index) in newsList"
        :key="index"
        v-show="showIndex===index"
      >
        <div
          v-for="(m,n) in i.content"
          v-if="n<7"
          :key="n"
          class="news-item-line"
        >
      <span
        @click="toDetail(m)">
        <strong style="font-size: 10px"> <img :src="logo" class="dian" alt=""></strong>
        {{m.title}}</span>
          <span style="flex-shrink: 0">{{'【'+m.check_time+'】'}}</span>
        </div>
      </div>
      <div class="img" @click="toSzf()">
        <img width="100%" height="100%" src="../assets/zhengfu-link.jpg"/>
      </div>
    </div>
  </div>
</template>

<script>
import dian from '@/assets/dian.png'
import axios from "axios";

export default {
  name: "Neck",
  data() {
    return {
      logo:dian,
      activeName: "first",
      showIndex:0,
      tuList:[],
      szfNewsList:[],
      newsList: []
    }
  },
  props:{
    newList:{
      type:Array,
      required: true
    }
  },
  watch:{
    newList:function (){
      for(let i=0;i<2;i++){
        this.tuList.push(
          {
            title: this.newList[0].content[i].title,
            img: this.newList[0].content[i].thumbnail,
          }
        )
        this.tuList.push(
          {
            title: this.newList[1].content[i].title,
            img: this.newList[1].content[i].thumbnail,
          }
        )
      }
      this.newsList = [...this.newList]
      // this.getSzfNews()
    },
  },
  methods: {
    toSzf() {
      window.open("https://www.sc.gov.cn/10462/c109616/comlist_15.shtml")
    },
    // 爬取省政府新闻
    async getSzfNews () {
      axios.get('/static/szf').then(resp => {
        const htmlDom = $(resp.data)
        const news = htmlDom.find('#dash-table li a')
        const times = htmlDom.find('#dash-table li span')
        news.splice(0, 8).forEach((item, index) => {
          this.szfNewsList.push({
            title: item.innerText,
            url: `https://www.sc.gov.cn${item.pathname}`,
            check_time: times[index].innerText.replace('(', '').replace(')', '')
          })
        })
        this.newsList.unshift({
          name: '省政府信息',
          content: this.szfNewsList
        })
      })
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
      setIndex(index){
        this.showIndex=index
      },
    toList (id) {
      // if (this.showIndex === 0) {
      //   window.open("https://www.sc.gov.cn/10462/c109616/comlist_15.shtml")
      // }else
        this.$router.push(`/news/${id}`)
    },
    toDetail(item){
      // if (this.showIndex === 0) {
      //   window.open(item.url)
      // }else
        this.$router.push(`/content/${item.id}`)
    }
  },
}
</script>

<style scoped>
.container {
  /*width: 1290px;*/
  width: 100%;
  height: 370px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}
.dian{
  position: relative;
  top:5px;
  width: 20px;
  height: 20px;
}
.swipper{
  background-color: white;
  width: 45%;
}

.swipper >>> .el-carousel__arrow {
  font-size: 24px;
}
.swipper >>> .el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #fff;
  opacity: .48;
}
.swipper >>> .is-active .el-carousel__button {
  opacity: 1;
}
.swipper >>>  .el-carousel__indicators--horizontal{
  left: 86%;
}

.swipper {
  /*width: 550px;*/
  /*height: 345px;*/
  box-sizing: border-box;
  flex: 1;
  height: 100%;
  margin-right: 10px;
}
.desc {
  position: absolute;
  width: 100%;
  height: 40px;
  line-height: 40px;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
}
.desc p{
  position: relative;
  left: 10px;
  color: white;
  margin: 0;
  padding: 0;
}
a {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 80%;
  color: #fff;
}
a:hover {
  text-decoration: underline;
  cursor: pointer;
}



.swipper-img {
  width: 597px;
  height: calc(590px*5/8);
}

.container >>> .el-tabs__active-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 0;
  background-color: #409EFF;
  z-index: 1;}

.container >>> .el-tabs__item {
  padding: 0 10px;
  height: 40px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 40px;
  display: inline-block;
  list-style: none;
  font-size: 14px;
  color: #999;
  position: relative;
  font-weight: bold;
}

.nes-wrapper{
  width: 52%;
  height: 95%;
  background-color: white;
  padding: 10px;
  position: relative;
  box-shadow: 0 0 2px #fff;
  border: 1px solid #E6E6E6;
}
.nes-wrapper .img {
  cursor: pointer;
}

.nes-header{
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
}
.header-item{
  position: relative;
  width: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  margin-right: 2px;
  height: 100%;
  font-weight: 700;
  color:#999999;
  margin-bottom: 15px;
}
.header-item:hover{
  color: #088A29;
  cursor: pointer;
  /*box-shadow: 0px 0px 10px #000;*/
}
.header-item:hover #san{
  display: block;
}
.header-item-active{
  color: #088A29;
}
.news-item-line{
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  font-size: 14px;
  position: relative;
  /*width: 100%;*/
  color: #999999;
}
.news-item-line span:first-child:hover{
  color: #088A29;
  cursor: pointer;
  text-decoration: underline;
}
.news-item-line span:first-child{
  font-size: 18px;
  color: #585858;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.nes-add{
  font-size: 16px;
  position: absolute;
  right: 10px;
  color: #999999;
}
.nes-add:hover{
  color: #088A29;
  cursor: pointer;
  text-decoration: underline;
}



</style>



// WEBPACK FOOTER //
// src/components/Neck.vue